import axios, { AxiosResponse } from "axios";
import { General } from "./general";
import { Programa } from "../models/programas.model";
import { ProgramaView } from "../models/programasView.model";
import ProgramaViewFilter from "../models/programaViewFilter.model";

export function ProgramasService(props?: any) {
    const getProgramas = async (): Promise<AxiosResponse<Programa[]>> => {
        return axios.get<Programa[]>(`${General.API_URL}/GetProgramas`);
    }
    function getProgramaPorId(value: number) {
        return axios.get<Programa>(`${General.API_URL}/GetProgramas/${value}`);
    }

    const getProgramasView = async (filter: ProgramaViewFilter): Promise<AxiosResponse<ProgramaView[]>> => {
        return axios.post<ProgramaView[]>(`${General.API_URL}/GetProgramasView`, filter);
    }
    const saveProgramas = (body: Programa): Promise<any> => {
        return axios.put(`${General.API_URL}/SaveProgramas`, body)
    }

    return (
        {
            getProgramas,
            getProgramasView,
            getProgramaPorId,
            saveProgramas
        }
    );

}